import { Component, OnInit } from '@angular/core';
import {ChangePasswordModel} from '../../../models/change-password-model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MyAccountService} from '../../../services/my-account.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PasswordValidator} from '../../../validators/password-validator';
import {ConfirmTotpModel} from '../../../models/confirm-totp-model';
import {ToastService} from 'angular-toastify';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {setAuthToken} from '../../../helpers/storage-helper';
import {RoleService} from '../../../services/role.service';

@Component({
  selector: 'app-activate-totp',
  templateUrl: './activate-totp.component.html',
  styleUrls: ['./activate-totp.component.css']
})
export class ActivateTotpComponent implements OnInit {

  qrUrlSafe: SafeResourceUrl;

  totpForm: FormGroup;
  showQrCode = false;
  qrTosChecked = false;
  alreadyActive = false;
  isLoadingQrCode = false;

  constructor(
    private myAccountService: MyAccountService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private _toastService: ToastService,
    private sanitizer: DomSanitizer,
    private roleService: RoleService,
  ) { }

  ngOnInit(): void {

    if ( this.roleService.hasRoles('multi_factor_auth')) {
      this.alreadyActive = true;
      return;
    }


    this.totpForm = this.formBuilder.group({
      totp: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(6)]],

    }, {

    });

  }

  submit() {
    const model = new ConfirmTotpModel();
    model.totp = this.totpForm.value.totp;

    this.myAccountService.confirmTotp(model).subscribe(data => {
      this._toastService.success(
        'Two-Factor Authentication has been set up successfully'
      );

      const remind = false;
      setAuthToken(data.authToken, remind);
      this.roleService.setRoles(data.roles, remind);

      this.myAccountService.announceMission('hey');

      if ( data.needTwoFactor ) {
        this.router.navigate(['enter-2fa']);
        return;
      }

      this.returnBack();
    });
  }

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }


  activateTotp() {
    this.isLoadingQrCode = true;
    this.myAccountService.activateTotp().subscribe(result => {

      const disposition = result.headers.get('Content-Disposition');
      const contentType = result.headers.get('Content-Type');
      const filename = disposition.split(';')[1].trim().split('=')[1];

      const blob = new Blob([result.body], { type: contentType });
      //FileSaver.saveAs(blob , filename);
      const fileURL = URL.createObjectURL(blob);


      this.qrUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      this.isLoadingQrCode = false;
      this.showQrCode = true;
    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
    });
  }


}
